import { render, staticRenderFns } from "./TarBar.vue?vue&type=template&id=1e3bb945&scoped=true&"
import script from "./TarBar.vue?vue&type=script&lang=js&"
export * from "./TarBar.vue?vue&type=script&lang=js&"
import style0 from "./TarBar.vue?vue&type=style&index=0&id=1e3bb945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../workspace/yajatravel/mp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3bb945",
  null
  
)

export default component.exports